angular.module('jv.candidates.LinkedIn.controller', [])
    .controller('jvCandidatesLinkedInController', [
        '$scope', '$window', 'jvHireUrlService',
        function ($scope, $window, jvHireUrlService) {

            $scope.liApiRestUrl = $window.jvUrls.jhire + '/action/liintegration/li-id/{0}';
            $scope.liIframeUrl = $scope.liApiRestUrl.format($window.companyEID || $window._jvselfUser.companyEId)+'?widget=US';
            $scope.flags.loading = false;
            $scope.flags.filterExpanded = true;
            //flag to do validation for selected candidate
            $scope.noCandidateSelected = false;
            //navigationListConfig for profile and search page links
            $scope.navigationListConfig = {
                actionTitle: i18n['SEARCH'],
                sortOptions: [
                    {
                        value: i18n['APPLICATIONS'],
                        id: 0,
                        action: 'applications'
                    },
                    {
                        value: i18n['PROFILES'],
                        id: 1,
                        action: 'profiles'
                    },
                    {
                        value: 'LinkedIn',
                        id: 2,
                        action: 'linkedIn'
                    }
                ],
                selectedOption: 2
            };

            //watch dropdown selection
            $scope.$watch('navigationListConfig.selectedOption', function (newValue, oldValue) {
                if (angular.isDefined(newValue) && newValue != -1) {
                    triggerNavigationAction($scope.navigationListConfig.sortOptions[newValue].action);
                }
            });

            //redirect to profile list page
            var goToApplicationListPage = function () {
                $window.location.href = jvHireUrlService.getCandidateListPageUrl();
            };

            //redirect to profile list page
            var goToProfileListPage = function () {
                var url = $scope.jvUrls.jhire + '/modules/candidates/list.html';
                $window.location.href = url;
            };

            //trigger navigation action dropdown
            var triggerNavigationAction = function (action) {
                switch (action) {
                    case 'applications':
                        goToApplicationListPage();
                        break;
                    case 'profiles':
                        goToProfileListPage();
                        break;
                }
            };

            //watch dropdown selection
            $scope.$watch('actionListConfig.selectedOption', function (newValue, oldValue) {
                if (angular.isDefined(newValue) && newValue != -1) {
                    triggerAction($scope.actionListConfig.sortOptions[newValue].action);
                    $scope.actionListConfig.selectedOption = -1;
                }
            });
        }
    ]);